import React from 'react';

import SwitchField from '@dashboard/components/form/fields/SwitchField';
import { Tooltip } from '@mui/material';

type Props = {
  name: string;
};

export default function DisableStepCheckbox({ name }: Props) {
  return (
    <Tooltip title="Turn step on/off">
      <span>
        <SwitchField useNegativeLogic name={`${name}.disabled`} />
      </span>
    </Tooltip>
  );
}
